<app-login
    [apiEndpoint]="endPoint"
    [displayTopHeader]="false"
    [successLink]="'period-readings'"
    [imageSrc]="'../../../assets/logos/saCentre.png'"
    [registerUserLink]="false"
    [registerLabel]="'Register'"
    [verifyEmailLink]="'/verify'"
    [logoStyle]="logoStyle"
    (loginCompleted)="getUser($event)"
    [passwordResetRequiredLink]="'login/reset-password'"
    [forgotPasswordFields]="forgotPasswordPopupFields"
    [cardWidth]="'300px'"
    [divHeight]="'90vh'"
  >
  </app-login>
<!--<div class="displayLibsCenter" fxFlex="33"
     fxLayout="column" fxLayoutAlign="center center">
  <lib-login [displayTopHeader]="false"
             [passwordResetRequiredLink]="'auth/reset-admin-password'"
             [forgotPasswordConfirmRoute]="'auth/reset-password'"
             [registerUserLink]="true"
             [registerRoute]="'auth/register'"
             [successLink]="'dashboard'"
             [forgotPasswordLink]='true'
             [forgotPasswordRoute]="'auth/forgot-password'"
             [logoImage]="'../../../../assets/grapes.png'"
             (loginCompleted)="getUser($event)"
             [apiEndpoint]="endPoint"
             [formFieldOutline]="'outline'"
             [userNameEmailLabel]="'Email'"
             (errorState)="displayErrorMessage($event)"></lib-login>
</div>-->
